import { render } from "./BoardView.vue?vue&type=template&id=0ac90726&scoped=true"
import script from "./BoardView.vue?vue&type=script&lang=js"
export * from "./BoardView.vue?vue&type=script&lang=js"

import "./BoardView.vue?vue&type=style&index=0&id=0ac90726&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac90726"],['__file',"src/views/userSupport/board/BoardView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ac90726"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ac90726', __exports__)) {
    api.reload('0ac90726', __exports__)
  }
  
  module.hot.accept("./BoardView.vue?vue&type=template&id=0ac90726&scoped=true", () => {
    api.rerender('0ac90726', render)
  })

}


export default __exports__